import { GetServerSideProps } from 'next';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import ProgramComponent from '@/components/app/program/ProgramComponent';
import Layout from '@/components/layout/LayoutWrapper';
import { useInitializeProgram } from '@/hooks/app/useInitializeProgram';
import { useProgramInfo } from '@/hooks/app/useProgramInfo';
import { useProgramState } from '@/hooks/store';
import messages from '@/messages/messages';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const Program = (): ReactElement => {
	const { formatMessage } = useIntl();
	const program = useProgramState();
	const { image } = useProgramInfo();

	useInitializeProgram();

	return (
		<Layout
			pageName="program"
			customSeo={{
				imageUrl: image?.url,
				title: formatMessage(messages.programPageSeoTitle, {
					title: program?.title,
					narrator: program?.narrator?.name,
				}),
				description: formatMessage(messages.programPageSeoDescription, { description: program?.description }),
				primaryDescription: formatMessage(messages.programPageSeoDescription, {
					description: program?.description,
				}),
			}}
		>
			<ProgramComponent />
		</Layout>
	);
};

export default Program;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	const program = initialState?.program ?? null;

	return {
		props: {
			initialState: {
				...initialState,
				theme: {
					webAppLayout: 'program',
				},
			},
			program,
		},
		notFound: !program || !program?.published_at,
	};
};
